var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'carousel-button',
    { 'carousel-button--active': _vm.active },
    { 'carousel-button--disabled': _vm.disabled }
  ],attrs:{"type":"button"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }